export const documentValidationFieldLabels = {
  docNum: 'Bizonylatszám',
  docStatus: 'Státusz',
  customStatus: 'Egyedi státusz',
  stornoId: 'Stornó azonosító',
  docDate: 'Bizonylat dátuma',
  issueDate: 'Kiállítás dátuma',
  dueDate: 'Esedékesség',
  companyId: 'Üzleti partner',
  companyCode: 'Partnerkód',
  companyName: 'Partner név',
  companyContactId: 'Kapcsolattartó',
  shortName: 'Rövid név',
  incotermCity: 'Paritás város',
  companyWarning: 'Figyelmeztetés',
  currencyCode: 'Pénznem',
  exchangeRate: 'Árfolyam',
  paymentMethodId: 'Fizetési mód',
  reference: 'Hivatkozás',
  employeeId: 'Munkatárs',
  projectId: 'Projekt',
  projectOrderNumber: 'Projekt rendelési szám',
  costCenterCode: 'Költséghely',
  salesOrPurchasePersonId: 'Beszerző/Értékesítő',
  billingAdressId: 'Számlázási cím',
  billingCountry: 'Számlázási ország',
  billingProvince: 'Számlázási tartomány',
  billingPostCode: 'Számlázási irányítószám',
  billingCity: 'Számlázási város',
  billingStreetAddress: 'Számlázási utca',
  shippingAdressId: 'Szállítási cím',
  shippingCountry: 'Szállítási ország',
  shippingProvince: 'Szállítási tartomány',
  shippingPostCode: 'Szállítási irányítószám',
  shippingCity: 'Szállítási város',
  shippingStreetAddress: 'Szállítási utca',
  deliveryMethodId: 'Szállítási mód',
  incotermCode: 'Fuvarparitás',
  whsCode: 'Raktár',
  toWhsCode: 'Fogadó raktár',
  priceListId: 'Árlista',
  langCode: 'Nyelv',
  hunTaxNumber: 'Magyar adószám',
  euTaxNumber: 'EU adószám',
  foreignTaxNumber: 'Külföldi adószám',
  note: 'Megjegyzés',
  internalNote: 'Belső megjegyzés',
  extraCostTotal: 'Extra költség',
  extraCostNote: 'Extra költség megjegyzés',
  settledAmount: 'Kiegyenlített összeg',
  openAmount: 'Nyitott összeg',
  createdBy: 'Létrehozta',
  lineStatus: 'Sor státusz',
  itemCode: 'Cikkszám',
  itemName: 'Cikknév',
  drawingNumber: 'Rajzszám',
  itemCodeInBp: 'ÜP cikkszám',
  itemNameInBp: 'ÜP cikknév',
  qty: 'Mennyiség',
  quantityUnitId: 'Mennyiségi egység',
  toBinId: 'Fogadó tároló',
  unitPrice: 'Egységár',
  vatCode: 'ÁFA kód',
  vatPercent: 'ÁFA %',
  vatValue: 'ÁFA érték',
  netPrice: 'Nettó érték',
  grossPrice: 'Bruttó érték',
  grossUnitPrice: 'Bruttó egységár',
  ruleId: 'Kedvezmény szabály',
  discountPercent: 'Kedvezmény %',
  baseUnitPrice: 'Alap egységár',
  baseGrossUnitPrice: 'Alap bruttó egységár',
  vatValueInOwnCur: 'ÁFA saját pénznemben',
  netPriceInOwnCur: 'Nettó saját pénznemben',
  grossPriceInOwnCur: 'Bruttó saját pénznemben',
  weightChangeNumber: 'Súlyváltozás szám',
  weight: 'Súly',
  itemReference: 'Cikk hivatkozás',
  bpNote: 'Partner megjegyzés',
  isBillable: 'Számlázható',
  ameCode: 'ÁME-kód',
  finalUnitCost: 'Végső egységköltség',
  finalLineValue: 'Végső sorérték',
  landedCost: 'Landed cost',
  warranty: 'Garanciális',
  productionPrepared: 'Gyártásra előkészített',
  batchSn: 'Sarzs',
  binCode: 'Rakhely',
  binId: 'Rakhely azonosító',
  lot: 'LOT',
  supplierId: 'Beszállító',
  expDate: 'Lejárat',
  mnfDate: 'Gyártási dátum',
  batchAttribute1: 'Sarzs attribútum 1',
  batchAttribute2: 'Sarzs attribútum 2',
  comment: 'Megjegyzés',
  price: 'Ár',
  other: 'Egyéb',
  quantity: 'Mennyiség',
  amount: 'Összeg',
  date: 'Dátum',
  mode: 'Mód',
  name: 'Név',
  path: 'Elérési út',
  extension: 'Kiterjesztés',
};

export const documentTabErrorFieldSets = {
  LINE: new Set(['docLine']),
  LOGISTICS: new Set([
    'billingAdressId',
    'billingCountry',
    'billingProvince',
    'billingPostCode',
    'billingCity',
    'billingStreetAddress',
    'shippingAdressId',
    'shippingCountry',
    'shippingProvince',
    'shippingPostCode',
    'shippingCity',
    'shippingStreetAddress',
    'companyContactId',
    'deliveryMethodId',
    'incotermCode',
    'whsCode',
  ]),
  ADDITIONAL: new Set([
    'priceListId',
    'salesOrPurchasePersonId',
    'langCode',
    'hunTaxNumber',
    'euTaxNumber',
    'foreignTaxNumber',
    'createdBy',
  ]),
  DESCRIPTION: new Set(['note', 'internalNote']),
  ATTACHMENT: new Set(['attachment']),
  WARNING: new Set(['companyWarning']),
};

export const documentValidationSections = [
  {
    section: 'Tételsorok',
    roots: new Set(['docLine']),
    itemLabel: 'sor',
    nestedItemLabels: {
      docLineBatchSn: 'sarzs',
      docLineBin: 'rakhely',
    },
  },
  {
    section: 'Kiegyenlítés',
    roots: new Set(['settlement']),
    itemLabel: 'tétel',
  },
  {
    section: 'Csatolmányok',
    roots: new Set(['attachment']),
    itemLabel: 'csatolmány',
  },
  {
    section: 'Logisztika',
    fields: documentTabErrorFieldSets.LOGISTICS,
  },
  {
    section: 'További adatok',
    fields: documentTabErrorFieldSets.ADDITIONAL,
  },
  {
    section: 'Megjegyzés',
    fields: documentTabErrorFieldSets.DESCRIPTION,
  },
  {
    section: 'Figyelmeztetés',
    roots: documentTabErrorFieldSets.WARNING,
  },
  {
    section: 'Egyedi mezők',
    matcher: (root) => String(root).startsWith('joker_'),
  },
];
